// Probate ids (case reference numbers) are held as STRINGS throughout the front end.
//
// They go up to 9999000002360110, which is beyond JavaScript's largest exactly-representable
// integer (Number.MAX_SAFE_INTEGER = 9007199254740991). Held as a number, an id that high is
// silently rounded to a NEIGHBOURING value - e.g. clicking a probate opens the one next to it.
// The server sends them as JSON strings (see the server's LongToStringConverter) and they must
// stay strings end to end:
//   - never Number(), parseInt(), unary + or arithmetic on an id
//   - compare with === between two strings (never mix a string and a number)
//   - use the helpers below wherever ids need ordering
//
// Probate ids are always non-negative whole numbers, so "numeric order" of two id strings is:
// shorter string first, then plain character order for strings of equal length.

// Comparator for Array.prototype.sort - numeric order, without converting to a number.
export function compareProbateIds(a: string | null | undefined, b: string | null | undefined): number {
  const x = (a ?? '').trim();
  const y = (b ?? '').trim();
  if (x.length !== y.length) return x.length - y.length;
  return x < y ? -1 : x > y ? 1 : 0;
}

// Sort key for MatTableDataSource.sortingDataAccessor (which compares with < and >). Zero-padding
// to a fixed width makes plain string order equal numeric order. 20 digits covers the full
// range of a signed 64-bit integer.
export function probateIdSortKey(id: string | null | undefined): string {
  return (id ?? '').trim().padStart(20, '0');
}
